import { RtkErrorResponseOfVsGraphQL, VsGraphQLFetchArgs } from '../type';

export class VsGraphQLError extends Error {
  public override name: string;
  public override cause?: RtkErrorResponseOfVsGraphQL['errors'];
  fetchArgs: VsGraphQLFetchArgs;
  status: number;

  constructor(
    error: RtkErrorResponseOfVsGraphQL,
    args: VsGraphQLFetchArgs,
    subName?: string
  ) {
    super(
      `Request failed with status code ${error.status}: ${error.errors.map(e => e.message).join(', ')}`
    );

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, VsGraphQLError);
    }

    this.name = `VsGraphQLError${subName ? ` - ${subName}` : ''}`;
    this.status = error.status;
    this.fetchArgs = args;
    this.cause = error.errors;
  }
}
